import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JhiAlertService } from 'ng-jhipster';

import { ICargoGroupMySuffix } from 'src/app/shared/model/cargo-group-my-suffix.model';
import { CargoGroupMySuffixService } from './cargo-group-my-suffix.service';
import { IRuleMySuffix } from 'src/app/shared/model/rule-my-suffix.model';
import { RuleMySuffixService } from 'src/app/entities/rule-my-suffix';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { Principal } from 'src/app/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';
import { CommonUtils } from 'src/app/shared/util/common-utils';

@Component({
    selector: 'jhi-cargo-group-my-suffix-update',
    templateUrl: './cargo-group-my-suffix-update.component.html'
})
export class CargoGroupMySuffixUpdateComponent implements OnInit {
    private _cargoGroup: ICargoGroupMySuffix;
    isSaving: boolean;

    rules: IRuleMySuffix[];

    date : Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate()-1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate:any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }

    constructor(
        private jhiAlertService: JhiAlertService,
        private cargoGroupService: CargoGroupMySuffixService,
        private ruleService: RuleMySuffixService,
        private activatedRoute: ActivatedRoute,
        private principal:Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private languageChangeService:LanguageChangeService,
        
    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }

    ngOnInit() {
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ cargoGroup }) => {
            this.cargoGroup = cargoGroup;
        });
        
        this.fromEffeciveDate = {date:this.dateModel};
    }

    previousState() {
        window.history.back();
    }

    save() {
        // Sent string to backed from date object 
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.cargoGroup.fromEffectiveDate = incDate;
        this.openConfirmationModalForFutureRecordDeletion();
    }

    saveOrUpdate() {
        this.isSaving = true;
        // if (this.cargoGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.cargoGroup.id)) {
            this.subscribeToSaveResponse(this.cargoGroupService.update(this.cargoGroup));
        } else {
            this.subscribeToSaveResponse(this.cargoGroupService.create(this.cargoGroup));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<ICargoGroupMySuffix>>) {
        result.subscribe((res: HttpResponse<ICargoGroupMySuffix>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackRuleById(index: number, item: IRuleMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            // for (let i = 0; i < selectedVals.length; i++) {
            //     if (option.id === selectedVals[i].id) {
            //         return selectedVals[i];
            //     }
            // }
            for (let _selectedVal of selectedVals) {
                if (option.id === _selectedVal.id) {
                    return _selectedVal;
                }
            }
        }
        return option;
    }
    get cargoGroup() {
        return this._cargoGroup;
    }

    set cargoGroup(cargoGroup: ICargoGroupMySuffix) {
        this._cargoGroup = cargoGroup;
    }

    trimName(event) {
        if (this.cargoGroup.name) {
            this.cargoGroup.name = this.cargoGroup.name.trim();
        }
    }

    trimHSCode(event) {
        if (this.cargoGroup.taricCode) {
            this.cargoGroup.taricCode = this.cargoGroup.taricCode.trim();
        }
    }

    trimDescription(event) {
        if (this.cargoGroup.description) {
            this.cargoGroup.description = this.cargoGroup.description.trim();
        }
    }
    trimCargoName(event) {
        this.cargoGroup.name = this.cargoGroup.name.trim();
    }

    trimCargoHSCode(event) {
        this.cargoGroup.taricCode = this.cargoGroup.taricCode.trim();
    }

    trimCargoDescription(event) {
        this.cargoGroup.description = this.cargoGroup.description.trim();
    }

    // onDateChanged(event: IMyDateModel) {
    //     let date = this.principal.dateFormateClientToServer(event.date)
    //     console.log('onDateChanged(): ',date );
    // }

    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        console.log('onDateChanged(): ', selectedFromEffectiveDate);
        // if (this.cargoGroup.id !== null && this.cargoGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.cargoGroup.id)) {
            this.cargoGroupService.findByIdAndFromEffectiveDate(this.cargoGroup.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']){
                    this.cargoGroup = response.body['payLoad'];
                }
            });
        }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

   isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.cargoGroup.id !== null && this.cargoGroup.id !== undefined) {
        if (CommonUtils.isNotNil(this.cargoGroup.id)) {
            let form_data = {
                masterId: this.cargoGroup.id,
                futureDataType: FutureDataType.CARGO_GROUP.valueOf(),
                fromEffectiveDateFormatted: this.cargoGroup.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Cargo (' + this.cargoGroup.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.cargoGroup.id,
                futureDataType: FutureDataType.CARGO_GROUP.valueOf(),
                fromEffectiveDateFormatted: this.cargoGroup.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }
}
